import { Container, Button, Alert, Form, Table, Row, Col, Spinner, Modal } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import "./list-collections.css";
import { TiDelete, TiDocumentAdd  } from "react-icons/ti";

function ListCollections() {

    const [items, setItems]                             = useState([]);
    const [showAlert, setShowAlert]                     = useState(false);
    const [showLoader, setShowLoader]                   = useState(false);
    const [showDelete, setShowDelete]                   = useState(false);
    const [showAdd, setShowAdd]                         = useState(false);
    const [deleteId, setDeleteId]                       = useState(false);
    const [showAlertDelete, setShowAlertDelete]         = useState(false);
    const [inputNombre, setInputNombre]                 = useState("");
    const [guardando, setGuardando]                     = useState(false);

    const handleCloseDelete     = () => setShowDelete(false);
    const handleCloseAdd        = () => setShowAdd(false);
    // const handleAdd             = () => addEvento(deleteId);
    const handleDelete          = () => deleteEvento(deleteId);

    const deleteEvento=(id)=>{
                
            let ud = sessionStorage.getItem('userData');
            let userData = JSON.parse(ud);
    
            const instance = axios.create({
                    baseURL: '',
                    timeout: 5000,
                    headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                    });
            
                instance.get('../api/delete-collection/'+id)
                .then(response => {
                    if(response.status === 200){
                        setShowDelete(false);
                        setDeleteId("")
                        setShowAlertDelete(true)
                        getData()
                    }
                })

    }
    
    const getData= async () => {
        
        setShowLoader(true);
        let ud = sessionStorage.getItem('userData');
        let userData = JSON.parse(ud);

        const instance = axios.create({
                baseURL: '',
                timeout: 10000,
                headers: {'content-type': 'application/json', 'Authorization': 'Bearer '+userData.access_token}
                });
        

        await instance.get('../api/list-collections')
        .then(response => {
            setItems(JSON.parse(response.data))
            setShowLoader(false);
        })
    }

    useEffect(()=>{
        getData()
    },[])



    const handleSubmit = async (event) => {
        
        event.preventDefault();

        setGuardando(true);

        if( inputNombre ){
          
            let ud = sessionStorage.getItem('userData');
            let userData = JSON.parse(ud);
    
            var vuelto = {
                "nombre": inputNombre
            }
          
            await fetch("api/create-collection", {
                method: "POST",
                body: JSON.stringify(vuelto),
                headers: {'Content-Type':'application/json','Authorization': 'Bearer '+userData.access_token}
              })
              .then(response => {
                if(response.status === 200)
                    setShowAlert(true);
                    setInputNombre("");
                    setGuardando(false);
                    getData()
                    setShowAdd(false);
              })
              .catch(function (error) {
                console.log(error);
              });
        
        }
        else{
            alert("Faltan Datos, por favor complete el formulario");
            setGuardando(false);
        }

    };


    const handleShowDelete = (item_id) => {
        setShowDelete(true);
        setDeleteId(item_id)
    }

    const handleShowAdd= () => {
        setShowAdd(true);
    }

  return (
        <>
            <Container>

                <Row>
                    <Col md={8}>
                        <h1 className="mt-4">Collections</h1>
                    </Col>
                    <Col className='text-end'>
                        <TiDocumentAdd className='icono_listado icono_listado_big' onClick={() => handleShowAdd()} />
                    </Col>
                </Row>

                {
                    showLoader ? <>       
                    <div className='loader-div'>
                            <Spinner animation="border" className='spinner_color' color={'#097969'} role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner><br />
                            <h3 className='loading_txt'>Loading ...</h3>
                        </div></> : ""
                }
                <Alert className="mt-4" key="success" variant="success" show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                    Se guardó exitosamente la información.
                </Alert>

                <Alert className="mt-4" key="success" variant="success" show={showAlertDelete} onClose={() => setShowAlertDelete(false)} dismissible>
                    Se eliminó exitosamente la información.
                </Alert>

                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th className='encabezado_tabla'>#</th>
                            <th className='encabezado_tabla'>Nombre</th>
                            <th className='encabezado_tabla'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            items && items.length > 0 && items.map((item, index) => {
                                var liga = "list-collection/"+item
                                return (
                                    <tr>
                                        <td className='data_tabla'>{index+1}</td>
                                        <td className='data_tabla'><a href={liga}>{item}</a></td>
                                        <td className='data_tabla'><TiDelete className='icono_listado' onClick={() => handleShowDelete(item)} /></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>

            </Container>


            <Modal show={showAdd} onHide={handleCloseAdd}>
                <Modal.Header closeButton>
                <Modal.Title>Agregar collection</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label htmlFor="input_nombre">Nombre de la collection</Form.Label>
                                <Form.Control 
                                id="input_nombre"
                                type="text" 
                                placeholder="Nombre"
                                defaultValue={inputNombre}
                                onKeyUp={(e) => setInputNombre(e.target.value)}
                                required />
                        </Form.Group>

                    </Container>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseAdd}>
                    Cancelar
                </Button>
                    {!guardando ? (
                            <Button variant="primary" type="submit" onClick={(handleSubmit)}>
                                Guardar
                            </Button>
                        ) : (
                            <Button variant="primary" type="submit" disabled>
                                Guardando...
                            </Button>
                    )}
                </Modal.Footer>
            </Modal>


            <Modal show={showDelete} onHide={handleCloseDelete}>
                <Modal.Header closeButton>
                <Modal.Title>Eliminar collection</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Está seguro que desea eliminar esta collection?</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseDelete}>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={() => handleDelete()} >
                    Confirmar
                </Button>
                </Modal.Footer>
            </Modal>

        </>
  )
}

export default ListCollections;